import { buildTitle, buildDescription, buildZDL } from '../utils/zap';
import { FIXTURES, mergeParamsFixturesIntoZDL } from '../fixtures';

import { Fetch } from '../../shared/types';
import type { Zap, Metadata } from '../types';

export type Options = {
  accountId: number;
  meta: Metadata;
  /**
   * When `true`, create a scheduled transfer.
   * Otherwise, create a one-time transfer.
   */
  isRecurring: boolean;
};

export const createZap = (
  fetch: Fetch,
  { accountId, meta, isRecurring }: Options
): Promise<Zap> =>
  fetch<Zap>('/api/gulliver/storage/v1/zaps', {
    body: {
      title: buildTitle(meta),
      description: buildDescription(meta),
      zdl: mergeParamsFixturesIntoZDL(FIXTURES, buildZDL(meta, isRecurring)),
      kind: 'transfer',
    },
    params: {
      account_id: accountId,
    },
  });

export default createZap;
